<template>
  <div>
    <loadingCube v-if="!cis_loaded" :loadingMessage="'CIS TAX STATUS'"></loadingCube>
    <div class="row" v-if="notEmptyObject(hmrc_cis_status)">
      <div class="col-xl-4">
        <div class="tax_status" v-if="notEmptyObject(cis_status) && cis_status.cis_response !== null">
          <div class="ts_header">Tax Status</div>
          <div class="ts_body">
            <div v-if="cis_status.cis_response.worker_status === 'unmatched'" class="unmatched">
              <div class="match">Unmatched</div>
              <div class="perc">
                <span>30%</span>
              </div>
            </div>
            <div v-if="cis_status.cis_response.worker_status === 'matched'" class="matched">
              <div class="match">Matched</div>
              <div class="perc">
                <span v-if="cis_status.cis_response.tax_treatment === 'net'">20%</span>
                <span v-else-if="cis_status.cis_response.tax_treatment === 'gross'">0%</span>
              </div>
            </div>
          </div>
          <div class="ts_footer">
            <div class="v_num">
              <h5 class="mb-0">Verification Number</h5>
              <span>{{ cis_status.cis_response.worker_verification_number }}</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">Latest Verification Date</h5>
              <span class="mb-2 d-block" v-if="cis_status.date_last_verified !== null ">{{ cis_status.date_last_verified | formatDateTime }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">Latest Verification By</h5>
              <span class="mb-2 d-block" v-if="cis_status.verified_by_id !== null ">{{ cis_status.verified_by.first_name }} {{ cis_status.verified_by.surname }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
            <div class="v_date">
              <h5 class="mb-0">First Verification Date</h5>
              <span v-if="cis_status.date_first_verified !== null ">{{ cis_status.date_first_verified  | formatDateTime }}</span>
              <span class="mb-2 d-block" v-else>&nbsp;</span>
            </div>
          </div>
        </div>
        <div class="tax_status" v-else>
          <div class="ts_header">Tax Status</div>
          <div class="ts_body">
            <div class="unmatched">
              <div class="match">NOT VERIFIED</div>
              <div><i class="fas fa-times"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="row">
          <!-- Worker Information -->
          <div class="col-12">
            <b-card header="CIS VERIFICATION" header-tag="h4" body-class="mb-3 record_card_body">
              <div class="row">
                <div class="col-12">
                  <h5>CURRENT WORKER/COMPANY INFORMATION</h5>
                </div>
                <!-- Current Employment Status -->
                <div class="col-12 form-group">
                  <label class="form-label" for="w_employment_status">Current Employment Status</label>
                  <p id="w_employment_status">
                    <span v-if="worker.rel_company_info.employment_type !== null">{{ worker.rel_company_info.employment_type.value }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Self Employed UTR Number -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="personal_utr_number">Self Employed UTR Number</label>
                  <p id="personal_utr_number">
                    <span v-if="worker.rel_profile.personal_utr_number !== null">{{ worker.rel_profile.personal_utr_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- NI Number -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="w_ni_number">NI Number</label>
                  <p id="w_ni_number">
                    <span v-if="worker.rel_profile.ni_number !== null">{{ worker.rel_profile.ni_number }}</span><span v-else>&nbsp;</span></p>
                </div>
                <!-- Company Name -->
                <div class="col-12 form-group" v-if="worker.rel_company_info.employment_type.id === 32">
                  <label class="form-label" for="w_company_name">Trading Name</label>
                  <p id="w_company_name">
                    <span v-if="worker.rel_company_info.company_trading_name !== null">{{ worker.rel_company_info.company_trading_name }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Company UTR Number -->
                <div class="col-lg-6 form-group" v-if="worker.rel_company_info.employment_type_id === 32">
                  <label class="form-label" for="company_utr_number">Ltd Company UTR Number</label>
                  <p id="company_utr_number">
                    <span v-if="worker.rel_company_info.company_utr_number !== null">{{ worker.rel_company_info.company_utr_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- Limited Company LTD Number -->
                <div class="col-lg-6 form-group" v-if="worker.rel_company_info.employment_type_id === 32">
                  <label class="form-label" for="company_ltd_reg_number">LTD Registration Number</label>
                  <p id="company_ltd_reg_number">
                    <span v-if="worker.rel_company_info.company_ltd_reg_number !== null">{{ worker.rel_company_info.company_ltd_reg_number }}</span>
                    <span v-else>&nbsp;</span>
                  </p>
                </div>
                <!-- First Name -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="w_first_name">First Name(s)</label>
                  <p id="w_first_name"><span v-if="worker.person.first_name !== null">{{ worker.person.first_name }}</span><span v-else>&nbsp;</span></p>
                </div>
                <!-- Surname -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="w_surname">Surname</label>
                  <p id="w_surname"><span v-if="worker.person.surname !== null">{{ worker.person.surname }}</span><span v-else>&nbsp;</span></p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <hr class="mt-0">
                </div>
              </div>
              <ValidationObserver ref="verifyCIS" slim>
                <form role="form" @submit.prevent="verify_cis">
                  <div class="row">
                    <div class="col-12">
                      <h5>VERIFICATION INFORMATION</h5>
                    </div>

                    <!-- Employment Status -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Employment Status" tag="div" class="col-xl-7 form-group">
                      <label class="form-label" for="employment_type">Current Status</label>
                      <multiselect v-model="hmrc_cis_status.employment_type" id="employment_type" class="requiredField" :class="classes" name="employment_type" placeholder=""
                                   :options="ms_opts.employment_types" label="value" :show-labels="false" trackBy="id" @input="select_emp_type"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- UTR Number -->
                    <ValidationProvider rules="required|digits:10" v-slot="{errors, classes}" name="UTR Number" tag="div" class="col-xl-5 form-group">
                      <label class="form-label" for="utr_number">UTR Number</label>
                      <input type="search" v-model="hmrc_cis_status.utr_number" id="utr_number" name="utr_number" class="form-input requiredField" :class="classes" maxlength="10">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <!-- NI Number -->
                    <ValidationProvider v-if="hmrc_cis_status.employment_type !== null && hmrc_cis_status.employment_type.id !== 32"
                                        :rules="{ required: true, regex: /^[A-Z][A-Z][0-9][0-9][0-9][0-9][0-9][0-9][A-Z]$/ }" v-slot="{errors, classes}" name="NI Number" tag="div"
                                        class="col-lg-4 form-group">
                      <label class="form-label" for="ni_number">NI Number</label>
                      <input type="search" v-model="hmrc_cis_status.ni_number" id="ni_number" name="ni_number" class="form-input requiredField" :class="classes"
                             @input="forceUppercase($event, hmrc_cis_status, 'ni_number')">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- First Name -->
                    <ValidationProvider v-if="hmrc_cis_status.employment_type !== null && hmrc_cis_status.employment_type.id !== 32"
                                        :rules="{ required: true, regex: /^[A-Z]([a-z]*)?([-][A-Z][a-z]+)?$/ }" v-slot="{errors, classes}" name="First Name" tag="div" class="col-lg-4 form-group">
                      <label class="form-label" for="initial_first_name">Initial/First Name</label>
                      <input type="search" v-model="hmrc_cis_status.initial_first_name" id="initial_first_name" name="initial_first_name" class="form-input requiredField"
                             :class="classes" maxlength="255" @input="forceCapitalizeApostrophe($event, hmrc_cis_status, 'initial_first_name')">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Surname -->
                    <ValidationProvider v-if="hmrc_cis_status.employment_type !== null && hmrc_cis_status.employment_type.id !== 32"
                                        rules="required" v-slot="{errors, classes}" name="Surname" tag="div" class="col-lg-4 form-group">
                      <label class="form-label" for="surname">Surname</label>
                      <input type="search" v-model="hmrc_cis_status.surname" id="surname" name="surname" class="form-input requiredField" :class="classes" maxlength="255"
                             @input="forceCapitalizeApostrophe($event, hmrc_cis_status, 'surname')">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <!-- Trading Name -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Trading Name" tag="div" class="form-group col-xl-6"
                                        v-if="hmrc_cis_status.employment_type !== null && hmrc_cis_status.employment_type.id === 32">
                      <label class="form-label" for="trading_name">Trading Name</label>
                      <input type="search" v-model="hmrc_cis_status.trading_name" id="trading_name" name="trading_name" class="form-input requiredField" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Limited Company LTD Number -->
                    <ValidationProvider rules="required|ltdCompNoValidate" v-slot="{errors, classes}" name="LTD Reg Number" tag="div" class="form-group col-xl-6"
                                        v-if="hmrc_cis_status.employment_type !== null && hmrc_cis_status.employment_type.id === 32">
                      <label class="form-label" for="crn">LTD Registration Number (CRN)</label>
                      <input type="search" v-model="hmrc_cis_status.crn" id="crn" name="crn" class="form-input requiredField" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="col-lg-6 offset-lg-6">
                      <button type="submit" class="btn orcaBtn w-100 mt-0 sm_btn" :disabled="progress">
                        <span v-if="progress" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Verifying with HMRC ...</span>
                        <span v-else>HMRC Verification</span>
                      </button>
                    </div>
                  </div>
                  <div class="row" v-if="progress">
                    <div class="col-12 mt-4">
                      <div class="progress">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + cis_progress + '%'" :aria-valuenow="cis_progress"
                             aria-valuemin="0" :aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </b-card>
          </div>
          <div class="col-12">
            <!--          <b-card header="Manual Override" header-tag="h4" body-class="mb-3 pb-0 record_card_body">-->
            <!--            <div class="row">-->
            <!--              &lt;!&ndash; Employment Status &ndash;&gt;-->
            <!--              <ValidationProvider rules="required" v-slot="{errors, classes}" name="Tax Rate" tag="div" class="col-xl-6 form-group">-->
            <!--                <label class="form-label" for="override_tax_rate">Tax Rate</label>-->
            <!--                <multiselect v-model="override.tax_rate" id="override_tax_rate" class="" :class="classes" name="override_tax_rate" placeholder=""-->
            <!--                             :options="ms_opts.tax_rates" :show-labels="false"></multiselect>-->
            <!--                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>-->
            <!--              </ValidationProvider>-->
            <!--              &lt;!&ndash; Company UTR Number &ndash;&gt;-->
            <!--              <ValidationProvider rules="" v-slot="{errors, classes}" name="Verification Number" tag="div" class="form-group col-xl-6">-->
            <!--                <label class="form-label" for="override_verification_number">Verification Number</label>-->
            <!--                <input type="search" v-model="override.verification_number" id="override_verification_number" name="override_verification_number" class="form-input"-->
            <!--                       :class="classes">-->
            <!--                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>-->
            <!--              </ValidationProvider>-->
            <!--            </div>-->
            <!--          </b-card>-->
          </div>
        </div>

      </div>
      <div class="col-xl-12">
        <div class="col-12 mb-2">
            <statements v-if="worker" :worker="worker"></statements>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import loadingCube from "loaders/record_loader";
import statements from 'components/pages/finance/CIS/statements';

export default {
  name: "cis_verification",
  components: {
    loadingCube,
    Multiselect,
    statements,
  },
  props: ["worker", "cis_status", "cis_loaded"],
  data() {
    return {
      progress: false,
      xmlState: 'initial',
      cis_progress: 0,
      hmrc_cis_status: {},
      ms_opts: {
        employment_types: this.$store.state.crm_options.worker_employment_type.filter(et => et.id === 32 || et.id === 29),
        tax_rates: ['Higher Rate (30%)', 'Standard Rate (20%)', 'Gross (0%)']
      },
      override: {
        tax_rate: null,
        verification_number: ''
      }
    }
  },
  beforeMount() {
    this.hmrc_cis_status = Object.assign({}, this.cis_status)
  },
  methods: {
    verify_cis() {
      this.$refs.verifyCIS.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.verifyCIS);
        }
        else {
          this.progress = true;
          this.xmlState = 'validate';
          this.cis_progress = 33.33;
          // First Step Verification -> create request xml file
          axios.post(this.crmApiPath + 'hmrc/cis/verification/generate_xml_file', {
            worker_id: this.worker.id,
            details: this.hmrc_cis_status
          }).then(acknowledge => {
            if (acknowledge.data.status === 200) {
              this.$snotify.warning(acknowledge.data.message);
              this.xmlState = 'verify';
              this.cis_progress = 50;
              setTimeout(() => {
                // update first verified date if null
                if (this.hmrc_cis_status.date_first_verified === null) {
                  this.hmrc_cis_status.date_first_verified = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');
                }
                else {
                  this.hmrc_cis_status.date_first_verified = this.$moment.utc(this.hmrc_cis_status.date_first_verified).format('YYYY-MM-DD HH:mm:ss');
                }
                // update last verified date
                this.hmrc_cis_status.verified_by_id = this.$store.state.auth.me.id;
                this.hmrc_cis_status.date_last_verified = this.$moment.utc().format('YYYY-MM-DD HH:mm:ss');



                axios.post(this.crmApiPath + 'hmrc/cis/verification/generate_xml_poll', {
                  worker_id: this.worker.id,
                  correlationID: acknowledge.data.data,
                  hmrc_cis_status: this.hmrc_cis_status
                }).then(verified => {
                  if (verified.data.status === 200) {
                    this.cis_progress = 66.66;
                    this.$bus.$emit('worker:sage:export');
                    // update first verified date if null
                    // if (this.hmrc_cis_status.date_first_verified === null) {
                    //   this.hmrc_cis_status.date_first_verified = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                    // }
                    // else {
                    //   this.hmrc_cis_status.date_first_verified = this.$moment(this.hmrc_cis_status.date_first_verified).format('YYYY-MM-DD HH:mm:ss');
                    // }
                    // update last verified date
                    // this.hmrc_cis_status.verified_by_id = this.$store.state.auth.me.id;
                    // this.hmrc_cis_status.date_last_verified = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                    // axios.patch(this.crmApiPath + 'hmrc/cis/verification/update_cis_info/' + this.hmrc_cis_status.id, this.hmrc_cis_status).then(() => {
                      this.cis_progress = 100;
                      setTimeout(() => {
                        this.$bus.$emit('cis_tax_status::reload', {action: true});
                        this.$snotify.success(verified.data.message);
                        this.progress = false;
                        this.xmlState = 'initial';
                      }, 500);
                    // })
                  }
                  else {
                    this.$snotify.error(verified.data.message);
                    this.cis_progress = 0;
                    this.progress = false;
                  }
                });
              }, 10000);
            }
            else {
              this.$snotify.error(acknowledge.data.message);
              this.cis_progress = 0;
              this.progress = false;
            }
          });
        }
      });
    },
    select_emp_type() {
      if (this.hmrc_cis_status.employment_type.id === 32) {
        this.hmrc_cis_status.initial_first_name = null;
        this.hmrc_cis_status.ni_number = null;
        this.hmrc_cis_status.surname = null;
        // set
        this.hmrc_cis_status.crn = this.worker.rel_company_info.company_ltd_reg_number;
        this.hmrc_cis_status.trading_name = this.worker.rel_company_info.company_trading_name;
        this.hmrc_cis_status.utr_number = this.worker.rel_company_info.company_utr_number;
        this.hmrc_cis_status.employment_type_id = 32;
      }
      else if (this.hmrc_cis_status.employment_type.id === 29) {
        this.hmrc_cis_status.crn = null;
        this.hmrc_cis_status.trading_name = null;
        // set
        this.hmrc_cis_status.initial_first_name = this.worker.person.first_name;
        this.hmrc_cis_status.ni_number = this.worker.rel_profile.ni_number;
        this.hmrc_cis_status.surname = this.worker.person.surname;
        this.hmrc_cis_status.utr_number = this.worker.rel_profile.personal_utr_number;
        this.hmrc_cis_status.employment_type_id = 29;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tax_status {
  display:       block;
  border:        5px solid $bc_2;
  border-radius: $border_radius_2;
  margin-bottom: 20px;

  .ts_header {
    border-bottom:  5px solid $bc_2;
    text-align:     center;
    font-size:      1.75rem;
    font-weight:    bold;
    text-transform: uppercase;
  }

  .ts_body {
    .unmatched, .matched {
      font-size:      1.5rem;
      text-transform: uppercase;
      font-weight:    bold;
      text-align:     center;
    }

    .unmatched {
      color:      $white;
      background: $red;

      i {
        font-size: 3rem;
      }
    }

    .matched {
      color:      $white;
      background: $green;

      .perc {
        font-size: 2rem;
      }
    }
  }

  .ts_footer {
    padding:    10px;
    border-top: 5px solid $bc_2;
    text-align: center;

    .v_num {
      margin-bottom: 10px;

      h5 {
        font-size: 0.75rem;
      }
    }

    .v_date {
      h5 {
        font-size: 0.75rem;
      }
    }
  }
}

.progress-bar {
  background-color: $bc_1;
}
</style>
